import '../scss/main.scss';
import "@splidejs/splide/dist/css/splide.min.css";
import { Fancybox } from "@fancyapps/ui";
import '@fancyapps/ui/dist/fancybox/fancybox.css';

document.addEventListener("DOMContentLoaded", function() {
    Fancybox.bind("[data-fancybox]", {});
});